import CalendarDatePicker from "ui/components/comp-507";

export default function OngoingJobsFilters({ filters, setFilters }) {
    const handleDateRangeChange = (dateRange) => {
        setFilters({
            ...filters,
            startDate: dateRange?.from || undefined,
            endDate: dateRange?.to || undefined,
        });
    };

    const dateRange = {
        from: filters?.startDate,
        to: filters?.endDate,
    };

    return (
        <div className="flex gap-6">
            <CalendarDatePicker
                date={dateRange}
                setDate={handleDateRangeChange}
            />
        </div>
    );
}
